import { NegativeFillDiamond } from 'ui/icons/status/NegativeFillDiamond';
import { colors } from 'ui/theme/colors';
import { SelectErrorMsg } from './Select.styles';
import { ErrorMessageProps } from './types';

export const SelectErrorMessage = ({ children }: ErrorMessageProps) => (
  <SelectErrorMsg>
    <NegativeFillDiamond height={14} width={14} color={colors.iconDestructive} />
    {children}
  </SelectErrorMsg>
);
